import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSelectFeaturesStatisticsActive } from "../../ducks/selectFeatures/selectors";
import { setSelectFeaturesStatisticsActive } from "../../ducks/selectFeatures/selectFeatures";

export const useSelectFeaturesStatisticsActive = (): [boolean, (state: boolean) => void] => {
  const dispatch = useDispatch();
  const value = useSelector(getSelectFeaturesStatisticsActive);

  const update = useCallback(
    (state: boolean) => {
      dispatch(setSelectFeaturesStatisticsActive(state));
    },
    [dispatch],
  );

  return [value, update];
};
